import "./style.scss";
const SelectItem = () => {
    return (
        <>
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="animated-icon"
            >
                <path
                    d={
                        "M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2Z"
                    }
                    fill={"#212121"}
                />
                <path
                    d="M10.5795 15.58C10.3795 15.58 10.1895 15.5 10.0495 15.36L7.21945 12.53C6.92945 12.24 6.92945 11.76 7.21945 11.47C7.50945 11.18 7.98945 11.18 8.27945 11.47L10.5795 13.77L15.7195 8.62998C16.0095 8.33998 16.4895 8.33998 16.7795 8.62998C17.0695 8.91998 17.0695 9.39998 16.7795 9.68998L11.1095 15.36C10.9695 15.5 10.7795 15.58 10.5795 15.58Z"
                    fill={"white"}
                    fillOpacity={"1"}
                />
            </svg>
        </>
    );
};

export default SelectItem;
